import dayjs from 'dayjs';
import timezonePlugin from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import googleLogo from '@/images/logos/google.svg';
import { capitalize } from '@/utils';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

const { VITE_GOOGLE_CLIENT_ID } = import.meta.env;

class OAuth {
	constructor({ baseUrl, baseParams, provider, image }) {
		this.baseUrl = baseUrl;
		this.baseParams = baseParams || {};
		this.provider = provider;
		this.name = capitalize(provider);
		this.image = image;
	}

	getUrl({ type = 'login', language, authTrigger, fastCheckout, pdfId }) {
		const redirectOrigin =
			import.meta.env.VITE_BASE_URL || window.location.origin;
		const url = new URL(this.baseUrl);
		const state = { language };
		const googleAdId = localStorage.getItem('googleAdId');

		if (type === 'create' && googleAdId) {
			state.googleAdId = googleAdId;
		}

		if (authTrigger) {
			state.authTrigger = authTrigger;
		}

		if (fastCheckout) {
			state.fastCheckout = true;
		}

		if (pdfId) {
			state.pdfId = pdfId;
		}

		url.searchParams.append('state', JSON.stringify(state));

		url.searchParams.append(
			'redirect_uri',
			new URL(`/api/auth/oauth/${this.provider}/${type}`, redirectOrigin)
		);

		Object.entries(this.baseParams).forEach(([name, value]) => {
			url.searchParams.append(name, value);
		});

		return url.toString();
	}
}

const googleClient = new OAuth({
	baseUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
	baseParams: {
		scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
		response_type: 'code',
		client_id: VITE_GOOGLE_CLIENT_ID
	},
	provider: 'google',
	image: googleLogo
});

export const oauthClients = [googleClient];
